import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Create Push Notification Campaign',
  sent_title: 'Notification queued',
  sent_subtitle:
    'Your push notification has been sent to Apple and Google. Delivery confirmations arrive in about 15 minutes.',
  sent_info_banner:
    'You can close this dialog. We will keep checking and update the campaign’s delivery stats automatically.',
  circles: {
    sent_label: 'Sent',
    sent_sub: 'Pushed to subscribers',
    delivered_label: 'Delivered',
    delivered_sub: 'Waiting for Apple & Google',
    delivered_ready_short: 'Ready',
    delivered_ready_sub: 'Refresh to see the latest stats',
  },
  scheduled_title: 'Campaign scheduled',
  scheduled_body_line_1: 'Your push notification is scheduled for {{when}}.',
  scheduled_body_line_2:
    'We will send it automatically at that time. Delivery confirmations from Apple and Google become available about 15 minutes after sending.',
  recipients_count_one: 'Sent to {{count}} subscriber.',
  recipients_count_other: 'Sent to {{count}} subscribers.',
  close: 'Close',
  sections: {
    message: 'Message',
    audience: 'Audience',
    when: 'When to send',
    review: 'Review',
  },
  stepper: {
    message: 'Message',
    audience_when: 'When to send',
    review: 'Review',
  },
  blocked_reasons: {
    title_required: 'Add a title to continue.',
    body_required: 'Add a message body to continue.',
    offer_required: 'Pick an offer to continue.',
    promo_code_required: 'Pick a promo code to continue.',
    send_option_required: 'Choose when to send to continue.',
    scheduled_at_required: 'Pick a date and time to continue.',
  },
  fields: {
    title: {
      label: 'Title',
      placeholder: 'Enter notification title',
    },
    body: {
      label: 'Message Body',
      placeholder: 'Enter your message',
    },
    audience: {
      label: 'Audience',
    },
    send_options: {
      label: 'Send options',
    },
    date_and_time: {
      label: 'Date & Time',
      placeholder: 'Select date & time',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Send Now',
    [SendOptions.Schedule]: 'Schedule',
  },
  send_option_cards: {
    now: {
      title: 'Send now',
      description: 'Push out to all subscribers immediately.',
    },
    schedule: {
      title: 'Schedule',
      description: 'Pick a date and time in the future.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promotional 🚀',
      description: 'Promote an offer or a promo code.',
    },
    informational: {
      title: 'Informational ℹ️',
      description: 'Share news or an update — no discount attached.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'All users ({{count}} device)',
  },
  preview: {
    title: 'Preview',
    notifications: {
      title: 'Your notification title will appear here',
      body: 'Your message body will be displayed here with all the details...',
      now: 'Now',
    },
    estimated_reach: 'Reach',
  },
  summary: {
    title: 'Summary',
    reach: 'Reach',
    when: 'When',
    campaign_type: 'Campaign type',
    promo_code: 'Promo code',
    offer: 'Offer',
    test_audience: 'Send a test push first',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Daily send limit reached',
      description:
        'Hey! Sending more than 1 push notification a day makes users unhappy and can lead to app deletions. That’s why we limit manual pushes to 1/day. Please schedule this for tomorrow.',
    },
    offer_not_sendable: {
      title: 'Offer does not run today',
      description: 'Please choose a date in the future.',
    },
  },
  buttons: {
    send_now: 'Send Now',
    save: 'Save',
    save_as_draft: 'Save as draft',
    send_test: 'Send Test',
    draft_with_ai: 'Draft with AI',
    back: 'Back',
    next: 'Next',
  },
  feedback: {
    success: 'Campaign saved successfully',
    promo_code_expired: 'Promo code expired',
    error: 'Could not save the campaign. Please check your connection and try again.',
  },
};
